module.exports = __webpack_public_path__ + "img/img.5d40b521.png";